class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);
    this.onUpsellClick = this.handleUpsellClick.bind(this);
    
    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
    this.addEventListener('click', this.onUpsellClick);
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');

    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
      this.productId = parsedState.id;
      const sectionsToRender = this.getSectionsToRender();
      sectionsToRender.forEach((section => {
        const html = parsedState.sections[section.id];
        if (!html) return;

        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(html, section.selector);
      }));

      const missingSections = sectionsToRender
        .filter((section) => !parsedState.sections[section.id])
        .map((section) => section.id);

      if (missingSections.length) {
        this.fetchMissingSections(missingSections).then(() => {
          if (this.header) this.header.reveal();
          this.open();
        });
        return;
      }

      if (this.header) this.header.reveal();
      this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `#cart-notification-product-${this.productId}`,
      },
      {
        id: 'cart-notification-button'
      },
      {
        id: 'cart-notification-upsell'
      },
      {
        id: 'cart-notification-shipping'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const fragment = doc.querySelector(selector);
    return fragment ? fragment.innerHTML : doc.body.innerHTML;
  }

  fetchMissingSections(sectionIds) {
    const fetches = sectionIds.map((id) =>
      fetch(`${routes.cart_url}?section_id=${id}`)
        .then((response) => response.text())
        .then((html) => {
          if (!html) return;
          document.getElementById(id).innerHTML = this.getSectionInnerHTML(html);
        })
        .catch(() => {})
    );

    return Promise.all(fetches);
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  handleUpsellClick(event) {
    const button = event.target.closest('.cart-upsell__add');
    if (!button) return;

    const context = button.dataset.upsellContext || 'cart';
    if (context !== 'notification') return;

    event.preventDefault();

    if (button.classList.contains('is-loading')) return;

    const variantId = Number(button.dataset.upsellVariant);
    if (!variantId) return;

    button.classList.add('is-loading');
    button.setAttribute('disabled', true);

    const sections = this.getSectionsToRender().map((section) => section.id);
    const body = JSON.stringify({
      id: variantId,
      quantity: 1,
      sections,
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
      .then((response) => response.json())
      .then((state) => {
        this.renderContents(state);
      })
      .catch(() => {})
      .finally(() => {
        button.classList.remove('is-loading');
        button.removeAttribute('disabled');
      });
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
